import { forwardRef } from 'react';
import { AlertCircle, Loader2 } from 'lucide-react';
import { TableCell, TableRow } from '@/components/ui/table';

interface InfiniteLoadingRowProps {
  columnCount: number;
  isLoading: boolean | undefined;
  hasError?: boolean | undefined;
  onRetry?: () => void;
}

export const InfiniteLoadingRow = forwardRef<HTMLTableRowElement, InfiniteLoadingRowProps>(
  ({ columnCount, isLoading, hasError, onRetry }, ref) => (
    <TableRow ref={ref} className="hover:bg-transparent border-b-0">
      <TableCell colSpan={columnCount} className="py-4 text-center">
        {hasError ? (
          <span className="inline-flex items-center gap-2 text-xs text-destructive">
            <AlertCircle className="size-3.5" />
            Failed to load more.
            {onRetry ? (
              <button
                type="button"
                onClick={onRetry}
                className="font-medium underline-offset-2 hover:underline"
              >
                Retry
              </button>
            ) : null}
          </span>
        ) : isLoading ? (
          <span className="inline-flex items-center gap-2 text-xs text-muted-foreground">
            <Loader2 className="size-3.5 animate-spin" />
            Loading more...
          </span>
        ) : null}
      </TableCell>
    </TableRow>
  ),
);

InfiniteLoadingRow.displayName = 'InfiniteLoadingRow';
